<template>
  <div>
    <!-- begin row -->
    <div class="row row-space-2">
      <!-- begin col-12 -->
      <div class="col-lg-12">
        <div class="widget-chart" :class="{ 'inverse-mode': inverseMode }">
          <div
            class="widget-chart-content"
            :class="{ 'bg-black': inverseMode }"
          >
            <div class="mb-3">
              <FilterComponent
                @collection-data="data => setData(data)"
                @waiting="val => (waiting = val)"
              />
            </div>
            <BarChart
              :inverseMode="inverseMode"
              :loading="waiting"
              v-model="collection"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilterComponent from './components/filter-component.vue'
import BarChart from './components/bar-chart.vue'

export default {
  name: 'studentPerformance',
  components: {
    BarChart,
    FilterComponent
  },
  data() {
    return {
      inverseMode: false,
      waiting: false,
      collection: {
        grades: [],
        resources: []
      }
    }
  },
  methods: {
    setData(data) {
      if(data)
      {
        this.collection.grades = data.grades
        this.collection.resources = data.collection
      }else{
        this.collection.grades = []
        this.collection.resources = []
      }
    }
  }
}
</script>
<style scoped>
.widget-chart .widget-chart-content {
  margin-right: 0;
}
</style>
